import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

const links = [
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact Us" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/refunds", label: "Refunds & Cancellations" },
];

export const Footer = () => (
  <footer className="mt-16 border-t border-[#1E2433] bg-[#0b0d13]">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-10 sm:px-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <Link to="/" data-testid="footer-logo" className="flex items-center gap-2.5">
          <LogoMark size="sm" />
          <span className="font-display text-xl font-extrabold text-white">crazy<span className="text-emerald-400">One</span></span>
        </Link>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="text-sm text-slate-400 transition-colors hover:text-emerald-400">
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="flex flex-col gap-1 border-t border-[#1E2433] pt-6 text-xs text-slate-600">
        <p>© {new Date().getFullYear()} crazyOne. All rights reserved. Prices in Indian Rupees (INR ₹).</p>
        <p>Support: <a href="mailto:support@crazyone.app" className="text-slate-500 hover:text-emerald-400">support@crazyone.app</a></p>
      </div>
    </div>
  </footer>
);
